export default {
  courierAttendScoreChangeRecord: '/honour/client/courierAttendScoreChangeRecord'
}
